
/* styles */
require("!!../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-c5c00a6c\",\"scoped\":true,\"hasInlineConfig\":false}!../vue-loader/lib/selector?type=styles&index=0!./vue-datepicker-es6.vue")

var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./vue-datepicker-es6.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c5c00a6c\"}!../vue-loader/lib/selector?type=template&index=0!./vue-datepicker-es6.vue"),
  /* scopeId */
  "data-v-c5c00a6c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-datepicker/vue-datepicker-es6.vue
// module id = 18
// module chunks = 1